import jsPDF from "jspdf";
import brand_logo from "../../../assets/brand_logo.png";
import dayjs from "dayjs";

const loadImageAsBase64 = async (url) => {
  try {
    if (!url) return null;

    const res = await fetch(url);
    if (!res.ok) return null;

    const blob = await res.blob();

    return await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error("Image load failed:", url, error);
    return null;
  }
};

const getImageType = (base64 = "") => {
  if (base64.includes("image/jpeg") || base64.includes("image/jpg")) return "JPEG";
  if (base64.includes("image/webp")) return "WEBP";
  return "PNG";
};

const num = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

const safeJsonParse = (value, fallback = {}) => {
  try {
    if (!value) return fallback;
    if (typeof value === "object") return value;
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};

const generateA4PDFService = async ({
  bookIds = [],
  rooms = [],
  form = {},

  services = [],
  serviceTotal = 0,

  nights = 0,
  grandTotal = 0,
  paidAmount = 0,
  receivedAdvance = 0,
  remainingPayable = 0,
  discountAmount = 0,

  paymentStatus = "",
  loyaltyDiscountPercent = 0,
  loyaltyDiscountAmount = 0,

  gst = 0,
  gstPercent = 0,
  gstAmount = 0,
  gstType = "inclusive",

  headera4Img = "",
  headerImg = "",
  footerImg = "",

  totalHours = 0,
  bookingType = "Day",
  ratePerHour = 0,

  overdue_amount = 0,
  overdue_duration = "",
  early_checkin_amount = 0,

  finalRemainingPayable = 0,
  isHistory = false,
}) => {
  const doc = new jsPDF("p", "mm", "a4");

  const pageW = 210;
  const pageH = 297;
  const m = 10;
  const cW = pageW - m * 2;

  const C = {
    primary: [30, 41, 59],
    accent: [79, 70, 229],
    accentLight: [238, 242, 255],
    success: [22, 101, 52],
    warning: [180, 83, 9],
    label: [71, 85, 105],
    text: [15, 23, 42],
    muted: [100, 116, 139],
    border: [226, 232, 240],
    cardBg: [248, 250, 252],
    white: [255, 255, 255],
    danger: [185, 28, 28],
  };

  const rgb = (color, type = "text") => {
    if (type === "text") doc.setTextColor(...color);
    if (type === "fill") doc.setFillColor(...color);
    if (type === "draw") doc.setDrawColor(...color);
  };

  const line = (x1, y1, x2, y2, color = C.border) => {
    rgb(color, "draw");
    doc.setLineWidth(0.18);
    doc.line(x1, y1, x2, y2);
  };

  const fmtRs = (v) =>
    `Rs. ${Math.round(num(v)).toLocaleString("en-IN")}`;

  const cleanStatus = (v = "") => String(v || "").trim().toLowerCase();

  const serviceList = Array.isArray(services)
    ? services.filter((s) => s && cleanStatus(s.status) !== "cancelled")
    : [];

    

  const getServiceName = (item) =>
    item?.service_type === "custom"
      ? item?.service_name || "-"
      : item?.inhouse_service_name || item?.service_name || "-";

  const getServiceStatus = (item) => {
    const status =
      item?.payment_status ||
      item?.paymentStatus ||
      item?.service_payment_status ||
      item?.is_paid ||
      item?.paid_status ||
      item?.status ||
      "";

    if (status === true || status === 1 || status === "1") return "paid";

    const finalStatus = cleanStatus(status);

    if (["paid", "completed", "success", "fully paid"].includes(finalStatus)) {
      return "paid";
    }

    return "unpaid";
  };

  const getServiceAmount = (item) => {
    const qty = num(item?.quantity) || 1;
    const rate = num(item?.price) || num(item?.rate);
    return num(item?.total_amount) || qty * rate;
  };

  const finalServiceTotal =
    num(serviceTotal) ||
    serviceList.reduce((sum, item) => sum + getServiceAmount(item), 0);

  const unpaidServiceTotal = serviceList.reduce((sum, item) => {
    return getServiceStatus(item) === "paid"
      ? sum
      : sum + getServiceAmount(item);
  }, 0);

  const servicePaymentStatus =
    serviceList.length === 0
      ? "NO SERVICE REQUEST"
      : serviceList.every((item) => getServiceStatus(item) === "paid")
        ? "PAID"
        : "UNPAID";

  const pricingSummary = safeJsonParse(form?.pricing_summary, {});

  const finalGstPercent = num(gstPercent || gst);
  const finalGstAmount =
    num(gstAmount) ||
    num(pricingSummary?.gst_amount) ||
    0;

  const discount = num(discountAmount);
  const paid = num(paidAmount);
  const advance = num(receivedAdvance);
  const overdueAmt = num(overdue_amount);
  const earlyAmt = num(early_checkin_amount);

  let roomChargesTotal = 0;

  console.log("rooms*******",rooms);
  
  const roomRows = Array.isArray(rooms)
    ? rooms.map((roomItem) => {
        const roomName = roomItem?.room_name || roomItem?.room_type || "Room";
        const roomNo = roomItem?.room_number ? `#${roomItem.room_number}` : "-";

        const roomRate =
          num(roomItem?.rate_per_night) ||
          num(roomItem?.price_per_day) ||
          num(roomItem?.room_price);

          const ac_charge = num(roomItem?.ac_charge)
          const floor = roomItem?.floor

        const qty =
          num(nights) > 0
            ? num(nights)
            : num(totalHours) > 0
              ? num(totalHours)
              : 1;

        const amount =
          num(roomItem?.total_amount) ||
          num(roomItem?.base_total) ||
          num(roomItem?.room_total) ||
          roomRate * qty;

        roomChargesTotal += amount;

        return {
          room: `${roomName} ${roomNo}`,
          type: roomItem?.room_type || "-",
          rate: roomRate,
          qty,
          amount,
          floor,
          ac_charge,
        };
      })
    : [];

  roomChargesTotal += earlyAmt + overdueAmt;

//   const totalBillAmount =
//     num(grandTotal) ||
//     roomChargesTotal + finalServiceTotal + finalGstAmount - discount;

const grandTotalAfterDiscount =
  num(grandTotal) > 0
    ? num(grandTotal) - discount
    : Math.max(roomChargesTotal + finalServiceTotal - discount, 0);

const roomOnlyTotal = num(grandTotal) > 0
  ? num(grandTotal) - finalServiceTotal
  : roomChargesTotal;

const roomNetDue = Math.max(roomOnlyTotal - discount - advance, 0);
const serviceDue = unpaidServiceTotal;
const balanceDue = Math.max(roomNetDue + serviceDue, 0);

// const grandTotalAfterDiscount = Math.max(
//   roomChargesTotal - discount + finalServiceTotal,
//   0
// );

  const finalStatus =
    paymentStatus || (balanceDue <= 0 ? "FULLY PAID" : "PAYMENT PENDING");

  const fitImageByWidth = (base64, maxW) =>
    new Promise((resolve) => {
      const img = new Image();

      img.onload = () => {
        const ratio = img.height / img.width;
        resolve({
          base64,
          width: maxW,
          height: maxW * ratio,
          type: getImageType(base64),
        });
      };

      img.onerror = () =>
        resolve({
          base64,
          width: maxW,
          height: 22,
          type: getImageType(base64),
        });

      img.src = base64;
    });

  const rawHeader = await loadImageAsBase64(headera4Img || headerImg);
  const rawFooter = await loadImageAsBase64(footerImg);

  const headerImage = rawHeader ? await fitImageByWidth(rawHeader, pageW) : null;
  const footerImage = rawFooter ? await fitImageByWidth(rawFooter, pageW) : null;

  const HDR = headerImage ? headerImage.height : 24;
  const FTR = footerImage ? footerImage.height : 12;

  let y = 0;

  const addFooter = () => {
    const fy = pageH - FTR;

    if (footerImage) {
      doc.addImage(
        footerImage.base64,
        footerImage.type,
        0,
        fy,
        footerImage.width,
        footerImage.height
      );
      return;
    }

    rgb(C.primary, "fill");
    doc.rect(0, fy, pageW, FTR, "F");

    rgb(C.white, "text");
    doc.setFont("helvetica", "normal");
    doc.setFontSize(7);
    doc.text("Thank you for your stay. Visit again!", pageW / 2, fy + 7, {
      align: "center",
    });
  };

  const addHeader = () => {
    if (headerImage) {
      doc.addImage(
        headerImage.base64,
        headerImage.type,
        0,
        0,
        headerImage.width,
        headerImage.height
      );
      y = HDR + 3;
    } else {
      rgb(C.primary, "fill");
      doc.rect(0, 0, pageW, HDR, "F");

      try {
        doc.addImage(brand_logo, "PNG", 10, 5, 26, 12);
      } catch {}

      rgb(C.white, "text");
      doc.setFont("helvetica", "bold");
      doc.setFontSize(13);
      doc.text("TAX INVOICE", pageW / 2, 10, { align: "center" });

      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);
      doc.text("Booking Receipt", pageW / 2, 16, { align: "center" });

      y = HDR + 3;
    }

    line(m, y, pageW - m, y);
    y += 4;

      doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.setTextColor(180, 83, 9);
  // REPLACE
 // REPLACE
    doc.text("TAX INVOICE", pageW / 2, y + 3, { align: "center" });

    doc.setFont("helvetica", "normal");
    doc.setFontSize(7);
    doc.setTextColor(100, 116, 139);
 doc.text("S J SHETTY ENTERPRISES", pageW - m - 2, y + 2, { align: "right" });
doc.text("GSTIN: 29AFIFS3946L1Z8", pageW - m - 2, y + 6, { align: "right" });
y += 10;
  };

  const checkPage = (needed = 20) => {
    if (y + needed > pageH - FTR - 8) {
      addFooter();
      doc.addPage();
      addHeader();
    }
  };

  const sectionTitle = (title) => {
    checkPage(10);

    rgb(C.cardBg, "fill");
    doc.roundedRect(m, y, cW, 7, 1.5, 1.5, "F");

    rgb(C.border, "draw");
    doc.roundedRect(m, y, cW, 7, 1.5, 1.5);

    rgb(C.text, "text");
    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    doc.text(String(title).toUpperCase(), m + 3, y + 4.8);

    y += 10;
  };

  const smallPair = (x, label, value, width = 85) => {
    doc.setFontSize(7);
    doc.setFont("helvetica", "bold");
    rgb(C.label, "text");
    doc.text(`${String(label)}:`, x, y);

    doc.setFont("helvetica", "normal");
    rgb(C.text, "text");

    const lines = doc.splitTextToSize(String(value ?? "—"), width - 26);
    doc.text(lines, x + 25, y);

    return Math.max(5, lines.length * 4.2);
  };

  const drawTableHeader = (cols) => {
    rgb(C.primary, "fill");
    doc.roundedRect(m, y, cW, 8, 1.5, 1.5, "F");

    rgb(C.white, "text");
    doc.setFont("helvetica", "bold");
    doc.setFontSize(7);

    let x = m;
    cols.forEach((col) => {
      doc.text(col.title, x + 2, y + 5);
      x += col.w;
    });

    y += 8;
  };

  const drawTableRow = (cols, row, idx) => {
    const rowH = 9;

    checkPage(rowH + 3);

    rgb(idx % 2 === 0 ? C.cardBg : C.white, "fill");
    doc.rect(m, y, cW, rowH, "F");

    rgb(C.border, "draw");
    doc.rect(m, y, cW, rowH);

    rgb(C.text, "text");
    doc.setFont("helvetica", "normal");
    doc.setFontSize(6.6);

    let x = m;

    row.forEach((cell, i) => {
      const text = doc.splitTextToSize(String(cell ?? "-"), cols[i].w - 4);
      doc.text(text[0] || "-", x + 2, y + 5.8);
      x += cols[i].w;
    });

    y += rowH;
  };

  addHeader();

  const billNo = bookIds?.[0] || form?.br_id || form?.id || "-";

  rgb(C.accentLight, "fill");
  doc.roundedRect(m, y, cW, 9, 1.5, 1.5, "F");

  rgb(C.border, "draw");
  doc.roundedRect(m, y, cW, 9, 1.5, 1.5);

  rgb(C.accent, "text");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(7.5);
  doc.text("Bill No:", m + 3, y + 5.8);

  doc.setFont("courier", "bold");
  doc.text(String(billNo), m + 22, y + 5.8);

  rgb(balanceDue <= 0 ? C.success : C.warning, "text");
  doc.setFont("helvetica", "bold");
  doc.text(finalStatus, pageW - m - 3, y + 5.8, { align: "right" });

  y += 13;

  const startY = y;
  const colL = m;
  const colR = m + cW / 2 + 4;
  const colW = cW / 2 - 6;

  sectionTitle("Guest Details");

  const guestStartY = y;

  const guestPairs = [
    ["Name", form?.guest_name || "—"],
    ["Phone", form?.phone || "—"],
    ["Email", form?.email || "—"],
    ["GST No.", form?.customer_gst || "—"],
    ["ID Type", form?.id_type || "—"],
    ["ID No.", form?.id_number || "—"],
  ];

  if (form?.address) guestPairs.push(["Address", form.address]);

  guestPairs.forEach(([label, value]) => {
    y += smallPair(colL + 1, label, value, colW);
  });

  const afterGuestY = y;

  y = startY;

  sectionTitle("Stay Details");

  const stayPairs = [
    ["Booking Type", bookingType || "—"],
    [
      "Check-In",
      `${form?.check_in ? dayjs(form.check_in).format("DD-MM-YYYY") : "—"}${
        form?.check_in_time ? ` (${form.check_in_time})` : ""
      }`,
    ],
    [
      "Check-Out",
      `${form?.check_out ? dayjs(form.check_out).format("DD-MM-YYYY") : "—"}${
        form?.check_out_time ? ` (${form.check_out_time})` : ""
      }`,
    ],
    ["Nights", num(nights) > 0 ? `${nights}` : "—"],
    ["Guests", form?.guests || "—"],
["Pay Mode", (() => {
      const rows = Array.isArray(pricingSummary?.payment_rows)
        ? pricingSummary.payment_rows
        : typeof pricingSummary?.payment_rows === "string"
          ? (() => { try { return JSON.parse(pricingSummary.payment_rows); } catch { return []; } })()
          : [];
      if (rows.length > 0) {
        const modes = [...new Set(rows.map(r => r.mode).filter(Boolean))];
        return modes.join(" / ") || form?.payment_mode || "—";
      }
      return form?.payment_mode || "—";
    })()],
  ];

  if (num(ratePerHour) > 0) {
    // stayPairs.push(["Rate / Hour", fmtRs(ratePerHour)]);
  }

  stayPairs.forEach(([label, value]) => {
    y += smallPair(colR + 1, label, value, colW);
  });

  const afterStayY = y;

  y = Math.max(afterGuestY, afterStayY);

  line(pageW / 2, guestStartY - 10, pageW / 2, y + 1);
  y += 4;
  line(m, y, pageW - m, y);
  y += 4;

  sectionTitle(`Room Price List (${roomRows.length} ${roomRows.length === 1 ? "Room" : "Rooms"})`);

  const roomCols = [
    { title: "Room", w: 50 },
    { title: "Type", w: 35 },
    { title: "AC Price", w: 35 },
    { title: "Floor", w: 25 },
    { title: "Amount", w: 45 },
  ];

  drawTableHeader(roomCols);

  if (roomRows.length === 0) {
    drawTableRow(roomCols, ["No room details", "-", "-", "-", fmtRs(0)], 0);
  } else {
    roomRows.forEach((r, idx) => {
      drawTableRow(
        roomCols,
        [r.room, r.type, fmtRs(r.ac_charge), r.floor, fmtRs(r.amount)],
        idx
      );
    });
  }

  if (earlyAmt > 0) {
    drawTableRow(roomCols, ["Early Check-In", "-", "-", "-", fmtRs(earlyAmt)], roomRows.length + 1);
  }

  if (overdueAmt > 0) {
    drawTableRow(
      roomCols,
      [`Overdue ${overdue_duration ? `(${overdue_duration})` : ""}`, "-", "-", "-", fmtRs(overdueAmt)],
      roomRows.length + 2
    );
  }

y += 5;

if (serviceList.length > 0) {
    sectionTitle("Service Request Price List");

    const serviceCols = [
        { title: "Service", w: 58 },
        { title: "Qty", w: 22 },
        { title: "Rate", w: 35 },
        { title: "Amount", w: 38 },
        { title: "Status", w: 37 },
    ];

    drawTableHeader(serviceCols);

    serviceList.forEach((item, idx) => {
      const qty = num(item?.quantity) || 1;
      const rate = num(item?.price) || num(item?.rate);
      const amount = getServiceAmount(item);
      const status = getServiceStatus(item).toUpperCase();
      const category = item?.category ? ` (${item.category})` : "";

      drawTableRow(
        serviceCols,
        [
          `${idx + 1}. ${getServiceName(item)}${category}`,
          qty,
          fmtRs(rate),
          fmtRs(amount),
          status,
        ],
        idx
      );
 });

    y += 5;
}

  sectionTitle("Grand Total Summary");

  const payItems = [];

payItems.push([
  "Room Charges Total",
  fmtRs(num(grandTotal) > 0 ? num(grandTotal) - finalServiceTotal : roomChargesTotal)
]);
  // if (finalGstPercent > 0) {
  //   payItems.push([
  //     gstType === "inclusive"
  //       ? `GST (${finalGstPercent}%)`
  //       : `GST (${finalGstPercent}% Included)`,
  //     gstType === "inclusive" ? fmtRs(finalGstAmount) : "",
  //   ]);
  // }

 // REPLACE
if (finalGstPercent > 0) {
    if (gstType === "inclusive") {
      const half = finalGstAmount / 2;
      payItems.push([`CGST (${finalGstPercent / 2}%)`, fmtRs(half)]);
      payItems.push([`SGST (${finalGstPercent / 2}%)`, fmtRs(half)]);
    } else {
      payItems.push([`GST (${finalGstPercent}%) Included`, ""]);
    }
  }

if (serviceList.length > 0) {
    payItems.push(["Service Charges Total", fmtRs(finalServiceTotal)]);
    payItems.push(["Service Payment Status", servicePaymentStatus]);
    if (unpaidServiceTotal > 0) {
      payItems.push(["Unpaid Service Amount", fmtRs(unpaidServiceTotal)]);
    }
  }

  if (num(loyaltyDiscountPercent) > 0) {
    payItems.push([
      `Loyalty Discount (${loyaltyDiscountPercent}%)`,
      `- ${fmtRs(loyaltyDiscountAmount)}`,
    ]);
  }

  if (discount > 0) {
    payItems.push(["Discount Applied", `- ${fmtRs(discount)}`]);
  }

if (!isHistory) {
    if (advance > 0 && advance !== paid) payItems.push(["Advance Received", fmtRs(advance)]);
    if (paid > 0) payItems.push(["Paid Amount", fmtRs(paid)]);
}

  payItems.push(["Balance Due", fmtRs(balanceDue)]);

  checkPage(payItems.length * 7 + 20);

  const paymentBoxH = payItems.length * 7 + 8;

  rgb(C.cardBg, "fill");
  doc.roundedRect(m, y - 3, cW, paymentBoxH, 1.5, 1.5, "F");

  rgb(C.border, "draw");
  doc.roundedRect(m, y - 3, cW, paymentBoxH, 1.5, 1.5);

  payItems.forEach(([lbl, val], i) => {
    const rowY = y + i * 7;

    doc.setFont("helvetica", val ? "bold" : "normal");
    doc.setFontSize(val ? 7.2 : 6.5);
    rgb(val ? C.label : C.muted, "text");
    doc.text(lbl, m + 4, rowY + 2);

    if (val) {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(7.2);
      rgb(C.text, "text");
      doc.text(String(val), pageW - m - 4, rowY + 2, {
        align: "right",
      });
    }

    if (i < payItems.length - 1) {
      line(m + 4, rowY + 4.5, pageW - m - 4, rowY + 4.5, C.border);
    }
  });

  y += paymentBoxH + 4;

  checkPage(20);

  rgb(balanceDue <= 0 ? C.success : C.warning, "fill");
  doc.roundedRect(m, y, cW, 14, 2, 2, "F");

  rgb(C.white, "text");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.text("GRAND TOTAL", m + 4, y + 8.5);

  doc.setFontSize(12);
  doc.text(fmtRs(grandTotalAfterDiscount), pageW - m - 4, y + 8.5, {
    align: "right",
  });

  y += 18;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  rgb(C.text, "text");
  doc.text(`Payment Status: ${finalStatus}`, pageW / 2, y, {
    align: "center",
  });

  addFooter();

  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);

  window.open(pdfUrl, "_blank");

  const iframe = document.createElement("iframe");
  iframe.style.position = "fixed";
  iframe.style.right = "0";
  iframe.style.bottom = "0";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "0";
  iframe.src = pdfUrl;

  document.body.appendChild(iframe);

  iframe.onload = () => {
    iframe.contentWindow.focus();

    setTimeout(() => {
      iframe.contentWindow.print();
    }, 500);

    setTimeout(() => {
      document.body.removeChild(iframe);
      URL.revokeObjectURL(pdfUrl);
    }, 5000);
  };
};

export default generateA4PDFService;